import { render, staticRenderFns } from "./infocorriere.vue?vue&type=template&id=00128a84"
import script from "./infocorriere.vue?vue&type=script&lang=js"
export * from "./infocorriere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00128a84')) {
      api.createRecord('00128a84', component.options)
    } else {
      api.reload('00128a84', component.options)
    }
    module.hot.accept("./infocorriere.vue?vue&type=template&id=00128a84", function () {
      api.rerender('00128a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/infocorriere.vue"
export default component.exports